// mox-draft-timers.js — temporizador único + modo debug
(function () {
    'use strict';

    if (window.__MOX_TIMER_WIRED__) return;
    window.__MOX_TIMER_WIRED__ = true;

    // ======= DEBUG ============================================================
    // Actívalo en consola con:
    //   localStorage.setItem('mox:debug','1'); location.reload();
    // Apágalo con:
    //   localStorage.removeItem('mox:debug'); location.reload();
    const DEBUG = (window.MOX_DEBUG === true) || localStorage.getItem('mox:debug') === '1';
    const dbg = (...a) => { if (DEBUG) console.log('[moxi][timer]', ...a); };
    dbg('cargando mox-draft-timers.js');

    // ======= ESPERAR CONFIG JSON =============================================
    function getCfgNode() { return document.getElementById('mox-prereserva-config'); }

    function waitForCfg(cb) {
        if (getCfgNode()) { dbg('config JSON encontrado inmediatamente'); return cb(); }

        dbg('esperando JSON de config…');
        const onDom = () => {
            if (getCfgNode()) { document.removeEventListener('DOMContentLoaded', onDom); dbg('config JSON tras DOMContentLoaded'); cb(); }
        };
        document.addEventListener('DOMContentLoaded', onDom);

        const mo = new MutationObserver(() => {
            if (getCfgNode()) { mo.disconnect(); dbg('config JSON detectado por MutationObserver'); cb(); }
        });
        mo.observe(document.documentElement, { childList: true, subtree: true });
    }

    // ======= HELPERS ==========================================================
    function parseCfg() {
        try {
            const node = getCfgNode();
            // Verificar que el nodo exista y tenga contenido no vacío (después de trim)
            // Esto maneja correctamente strings con solo espacios en blanco
            if (!node || !node.textContent || !node.textContent.trim()) {
                dbg('config JSON no encontrado o vacío');
                return {};
            }
            const cfg = JSON.parse(node.textContent.trim());
            dbg('config leída', cfg);
            return cfg;
        } catch (e) {
            dbg('error parseando config JSON', e);
            return {};
        }
    }

    function isWeekend(cfg, date = new Date()) {
        const fridayStart = (cfg.weekend_starts_on || 'friday') === 'friday';
        const d = date.getDay(); // 0=Dom,1=Lun…5=Vie,6=Sáb
        return fridayStart ? (d === 5 || d === 6 || d === 0) : (d === 6 || d === 0);
    }

    function currentSlot(cfg) {
        if (isWeekend(cfg)) {
            return {
                visible: Number(cfg.weekend_visible_hours ?? 48),
                real: Number(cfg.weekend_real_hours ?? 72),
                message: cfg.weekend_message || ''
            };
        }
        return {
            visible: Number(cfg.weekday_visible_hours ?? 24),
            real: Number(cfg.weekday_real_hours ?? 40),
            message: cfg.weekday_message || ''
        };
    }

    function getDraft() {
        var cur = window.MOX_DRAFT && window.MOX_DRAFT.current;
        var d = (cur && (cur.draftOrder || cur)) || null;
        dbg('draft actual', d ? { id: d.id || d.name, createdAt: d.createdAt || d.created_at } : 'null');
        return d;
    }

    function getEndsMs(cfg) {
        const d = getDraft();
        const slot = currentSlot(cfg);
        if (!d) return { endV: NaN, endR: NaN, slot };

        // === fuente de verdad desde backend
        const realIsoMf = d?.realEnd?.value || null;      // prereserva.real_end
        const visIsoMf = d?.visibleEnd?.value || null;   // si algún día lo envías

        const created = d.createdAt || d.created_at;
        const visIso = visIsoMf || d.expiresAt_visible || d.expires_at_visible || null;
        const realIso = realIsoMf || d.expiresAt_real || d.expires_at_real || null;

        // endV: visible → metafield > expiresAt_visible > cálculo por slot
        const endV = visIso
            ? Date.parse(visIso)
            : created ? Date.parse(created) + slot.visible * 3600000 : NaN;

        // endR: real → metafield > expiresAt_real > cálculo por slot
        const endR = realIso
            ? Date.parse(realIso)
            : created ? Date.parse(created) + slot.real * 3600000 : NaN;

        dbg('ends calculados', {
            created, visIso, realIso,
            endV: isFinite(endV) ? new Date(endV).toISOString() : null,
            endR: isFinite(endR) ? new Date(endR).toISOString() : null,
            slot
        });

        return { endV, endR, slot };
    }


    // ======= DOM ==============================================================
    const $row = () => document.querySelector('[data-mox-timer-row]');
    const $timer = () => document.querySelector('[data-mox-timer]');
    const $label = () => document.querySelector('.mox-timer-label');

    const forceShow = (el) => { if (!el) return; el.hidden = false; el.removeAttribute('hidden'); el.style.display = ''; };
    const forceHide = (el) => { if (!el) return; el.hidden = true; el.setAttribute('hidden', ''); el.style.display = 'none'; };

    // ======= TIMER ============================================================
    let iv = null;
    const fmt = (n) => String(n).padStart(2, '0');

    function paintMessage(cfg) {
        const slot = currentSlot(cfg);
        const lb = $label();
        if (lb && slot.message) {
            lb.textContent = slot.message.replace('[H]', slot.visible);
            dbg('mensaje pintado', lb.textContent);
        }
    }

    function stop(reason) {
        if (iv) { clearInterval(iv); iv = null; }
        const t = $timer(); if (t) t.textContent = '';
        forceHide($row());
        dbg('contador oculto →', reason);
    }

    function tickOnce(endV) {
        const t = $timer(); if (!t) { dbg('no hay nodo [data-mox-timer]'); return; }

        const diff = endV - Date.now();
        if (!isFinite(diff) || diff <= 0) { stop('visible vencido'); return; }
        const hh = Math.floor(diff / 3600000);
        const mm = Math.floor((diff % 3600000) / 60000);
        const ss = Math.floor((diff % 60000) / 1000);
        t.textContent = `${fmt(hh)}:${fmt(mm)}:${fmt(ss)}`;
        forceShow($row());
    }

    function start() {
        if (iv) { clearInterval(iv); iv = null; }

        const cfg = parseCfg();
        window.MOX_CFG = cfg;

        paintMessage(cfg);

        const { endV, endR } = getEndsMs(cfg);

        // si el REAL venció → oculto y listo
        if (isFinite(endR) && endR <= Date.now()) {
            stop('real vencido');
            // document.dispatchEvent(new CustomEvent('mox:draft:none'));
            window.dispatchEvent(new CustomEvent('mox:draft:none'));
            return;
        }

        // si el VISIBLE venció → oculto y aviso al backend
        if (isFinite(endV) && endV <= Date.now()) {
            stop('visible vencido');
            document.dispatchEvent(new CustomEvent('mox:reserve:visible_end')); // ← clave
            return;
        }

        dbg('iniciando contador', {
            endV: new Date(endV).toLocaleString(),
            endR: new Date(endR).toLocaleString()
        });

        tickOnce(endV);
        iv = setInterval(() => {
            const { endV: v2, endR: r2 } = getEndsMs(cfg);
            if (isFinite(r2) && r2 <= Date.now()) {
                stop('real vencido en loop');
                // document.dispatchEvent(new CustomEvent('mox:draft:none'));
                window.dispatchEvent(new CustomEvent('mox:draft:none'));
                return;
            }
            tickOnce(v2);
        }, 1000);
    }

    // ======= INIT & EVENTS =====================================================
    waitForCfg(() => {
        // primera carrera
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => { dbg('DOMContentLoaded → start'); start(); }, { once: true });
        } else {
            dbg('DOM listo → start'); start();
        }

        // draft actualizada
        window.addEventListener('mox:draft:loaded', () => { dbg('evento mox:draft:loaded'); start(); });
        window.addEventListener('mox:draft:none', () => { dbg('evento mox:draft:none'); stop('sin draft'); });

        // sección recargada en editor
        document.addEventListener('shopify:section:load', () => { dbg('section:load → start'); start(); });
    });
})();

/* === MOX: ocultar/minicart cuando la draft ya está vencida por tiempo real === */
(function () {
    // ---- Helpers (seguros y compatibles) --------------------------------------
    function getCfg() {
        try {
            var el = document.getElementById('mox-prereserva-config');
            return el ? JSON.parse(el.textContent || '{}') : {};
        } catch (e) { return {}; }
    }
    function isWeekend(cfg) {
        var fri = (cfg.weekend_starts_on || 'friday') === 'friday';
        var d = new Date().getDay(); // 0=Dom, 5=Vie, 6=Sáb
        return fri ? (d === 5 || d === 6 || d === 0) : (d === 6 || d === 0);
    }
    function realEndTs(draft, cfg) {
        var d = draft && (draft.draftOrder || draft) || {};
        var H = 3600000;
        var created = new Date(d.createdAt || d.created_at || Date.now()).getTime();

        // 1) backend metafield
        if (d.realEnd && d.realEnd.value) return new Date(d.realEnd.value).getTime();

        // 2) fallback a expiresAt_real (legacy)
        if (d.expiresAt_real || d.expires_at_real) return new Date(d.expiresAt_real || d.expires_at_real).getTime();

        // 3) cálculo por slot si no hay nada
        var weekend = isWeekend(cfg);
        var real = Number(weekend ? (cfg.weekend_real_hours || 72) : (cfg.weekday_real_hours || 40));
        return created + real * H;
    }

    function getCurrentDraft() {
        var cur = window.MOX_DRAFT && window.MOX_DRAFT.current;
        return (cur && (cur.draftOrder || cur)) || null;
    }

    // ---- Chequeo de expiración (inmediato, en eventos y con un poll suave) ----
    var handled = false;
    function maybeExpireNow() {
        if (handled) return;
        var cfg = getCfg();
        var draft = getCurrentDraft();
        if (!draft) return;

        var ts = realEndTs(draft, cfg);
        if (isFinite(ts) && Date.now() > ts) {
            handled = true;
            console.log('[moxi] draft vencida por tiempo real -> mox:draft:none');
            // document.dispatchEvent(new CustomEvent('mox:draft:none'));
            window.dispatchEvent(new CustomEvent('mox:draft:none'));
        }
    }

    // 1) Al cargar
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', maybeExpireNow, { once: true });
    } else {
        maybeExpireNow();
    }

    // 2) Cada vez que llega/actualiza una draft
    window.addEventListener('mox:draft:loaded', function () {
        handled = false; // permitir re-chequeo para una nueva draft
        maybeExpireNow();
    });

    // 3) Poll barato por si cambia día (weekend/weekday) o reloj del usuario
    var poll = setInterval(maybeExpireNow, 15000);
    window.addEventListener('mox:draft:none', function () { clearInterval(poll); });

    // ---- Limpieza del drawer cuando no hay draft (o venció) -------------------
    window.addEventListener('mox:draft:none', function () {
        // Estado en memoria
        if (window.MOX_DRAFT) {
            window.MOX_DRAFT.current = null;
            window.MOX_DRAFT.state = 'none';
        }

        // DOM del drawer
        var items = document.querySelector('[data-mox-items]');
        var empty = document.querySelector('[data-mox-empty]');
        var footer = document.querySelector('[data-mox-footer]');
        var timerRow = document.querySelector('[data-mox-timer-row]');
        var panel = document.querySelector('[data-mox-panel]');
        var overlay = document.querySelector('[data-mox-overlay]');
        var counters = document.querySelectorAll('[data-mox-counter]');
        if (items) { items.innerHTML = ''; items.hidden = true; }
        if (empty) { empty.hidden = false; }
        if (footer) { footer.hidden = true; }
        if (timerRow) { timerRow.hidden = true; }
        for (var i = 0; i < counters.length; i++) counters[i].setAttribute('data-mox-counter', '0');

        // if (panel) panel.setAttribute('aria-hidden', 'true');
        // if (overlay) overlay.hidden = true;

        // Deshabilitar CTA de checkout por seguridad
        var btn = document.querySelector('[data-mox-checkout]');
        if (btn) {
            btn.setAttribute('disabled', '');
            btn.setAttribute('aria-disabled', 'true');
            btn.dataset.invoiceUrl = '';
            btn.href = '#';
        }
    });

    // === Handler único y idempotente para mox:draft:loaded (rehabilita CTA) ===
    (function () {
        function onDraftLoaded(e) {
            var btn = document.querySelector('[data-mox-checkout]');
            if (!btn) return;

            btn.removeAttribute('disabled');
            btn.removeAttribute('aria-disabled');
            btn.classList.remove('disabled', 'is-disabled');

            var d = (e.detail && (e.detail.draft?.draftOrder || e.detail.draft))
                || (window.MOX_DRAFT && (window.MOX_DRAFT.current?.draftOrder || window.MOX_DRAFT.current));
            var url = d?.invoiceUrl || d?.invoice_url || btn.dataset.invoiceUrl || '#';
            btn.dataset.invoiceUrl = url;
            btn.href = url;

            var empty = document.querySelector('[data-mox-empty]');
            var footer = document.querySelector('[data-mox-footer]');
            var items = document.querySelector('[data-mox-items]');
            if (items) items.hidden = false;
            if (empty) empty.hidden = true;
            if (footer) footer.hidden = false;
        }

        // idempotente
        window.MOX_onDraftLoaded = onDraftLoaded;
        window.removeEventListener('mox:draft:loaded', window.MOX_onDraftLoaded);
        window.addEventListener('mox:draft:loaded', window.MOX_onDraftLoaded);
    })();

})();



